class CashbackConverter {
  convertCashbackList = response => {
    if (!response?.rules) {
      return { items: [], count: 0 };
    }

    const result = {
      items: response.rules.map(item => ({
        id: item.id,
        providerType: item.provider_type,
        cashbackPercent: parseFloat(item.cashback_percent) || 0,
        durationDays: item.duration_days,
        startDate: item.start_date,
        endDate: item.end_date,
        isForAllPlayers: item.is_for_all_players,
        targetPlayerId: item.target_player_id,
        targetPlayerUsername: item.target_player_username || null,
        status: item.status,
        totalAccruedAmount: parseFloat(item.total_accrued_amount) || 0,
        createdAt: item.created_at,
        updatedAt: item.updated_at,
      })),
      count: response.total_count || 0,
      skip: response.skip || 0,
      limit: response.limit || 20,
    };

    return result;
  };
}

export { CashbackConverter };
